export { AutoplayIcon } from "./Autoplay.svg";
export { CloseIcon } from "./Close.svg";
export { GameRulesIcon } from "./GameRules.svg";
export { GameHistoryIcon } from "./GameHistory.svg";
export { GameSettingsIcon } from "./GameSettings.svg";
export { MenuIcon } from "./Menu.svg";
export { PaytableIcon } from "./Paytable.svg";
export { PlayIcon } from "./Play.svg";
export { QuickSpinIcon } from "./QuickSpin.svg";
export { QuickSpinActiveIcon } from "./QuickSpin.active.svg";
export { SoundActiveIcon } from "./Sound.active.svg";
export { SoundInactiveIcon } from "./Sound.inactive.svg";
export { SpinIcon } from "./Spin.svg";
export { StopIcon } from "./Stop.svg";
export { StopIconSmall } from "./Stop.small.svg";
export { HomeIcon } from "./Home.svg";
export { PluginIcon } from "./Plugin.svg";
export { IntroMovie } from "./IntroMovie.svg";
export { IntroScreen } from "./IntroScreen.svg";
export { SpacebarToSpin } from "./SpacebarToSpin.svg";
export { LeftHandMode } from "./LeftHandMode.svg";
export { KeyboardArrow } from "./KeyboardArrow.svg";
